import { css } from '@emotion/react';
import type * as React from 'react';
import { Skeleton } from '@verclam/ui-kit';

const skeletonStackStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

/** The loading placeholder of a dossier: a banner and a section. */
const SubjectDetailsSkeleton: React.FC = () => {
	return (
		<div css={skeletonStackStyle}>
			<Skeleton height="10rem" animation="wave" shape="rectangle" />
			<Skeleton height="14rem" animation="wave" shape="rectangle" />
		</div>
	);
};

export default SubjectDetailsSkeleton;
